import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-08-10'
        tag='Poshmark'
        title='The Poshmark Price Drop Strategy - A Seller`s Guide to More Sales'
      >
        <p>
          Poshmark sellers are well aware of how important pricing is in making a profit on the platform. But the thing
          is, the way to a sure sale is not always as simple as setting the lowest listing price possible (to the
          detriment of your profit margins). A cheap asking price is attractive to potential buyers for obvious reasons,
          but it doesn’t automatically translate to purchase all the time. For instance, a buyer may sometimes be wary
          of purchasing an item that’s priced suspiciously low. That is why when it comes to pricing, having a strategy
          is a must. Here, we are dishing out tips on how to strategically drop your prices.{' '}
        </p>
        ​<h3>Find context in setting prices</h3>​
        <p>
          Unless you are already confident on how much an item should go for, it helps to do a bit of research on the
          prices of similar items on the retailers’ website or check available listings on Poshmark to have an idea how
          much to drop an item’s price. Finding the retail price of items, especially for popular brands, shouldn’t be
          difficult. Just keep in mind to take into consideration the actual condition of your item to come up with a
          price that’s fair to you and the buyer.{' '}
        </p>
        ​<h3> Drop your Prices on Thursdays and Fridays</h3>​
        <p>
          Technically, you can drop your prices anytime. But why not take advantage of the best days to do it? At
          OneShop, our sales data shows that Thursdays and Fridays are your best bets to rake in sales, as most people
          get paid on either day. Time your markdowns and offers on these prime days of purchasing power. While you’re
          at it, schedule your activity around hours where potential buyers are avail – when potential buyers are most
          likely on the platform looking for their next purchase.{' '}
        </p>
        ​<h3>Be Responsive</h3>
        <p>
          Once you posted your dropped prices, standby for comments and promptly respond to them – don’t forget to tag
          the potential buyers accordingly so they won’t miss your reply. You wouldn’t want to miss an opportunity to
          make a sale just because you replied too late to inquiries. Also, be on the lookout for likers and potential
          buyers who make an offer – seal the deal fast with a counteroffer or an irresistible bargain like a bundle
          discount, if possible.{' '}
        </p>
        <h3>Make the most of Poshmark's Closet Clear Out</h3>​
        <p>
          Poshmark occasionally announces CCO, a one or two-day promotional event wherein the platform shoulders the
          shipping fee for items dropped at least 10% of their lowest historical price (and with the final price
          amounting to $10 and up). Likers of items with dropped prices automatically get notified, as long as the
          notification button is turned on!{' '}
        </p>
        ​
        <p>
          Even if there is no Closet Clear Out promotion going on, both sellers and buyers can take advantage of the
          price drop notification whenever there’s at least a 10% drop on the liked item worth $10 and up. The only
          difference is that the shipping will not be automatically on Poshmark’s tab. Shipping discounts are applicable
          on certain listings only, selected at random.{' '}
        </p>
        ​<h3>Relist Old Listings</h3>​
        <p>
          You may also want to try a price “drop” strategy that doesn’t involve slashing down the prices upfront. Check
          your inventory (we see you, unsold Nike jacket and Guess mom jeans!), Google what’s on-trend, and put a spin
          on these unwanted things with better photos, snappier descriptions, and higher prices. If they get sold right
          then and there, good for you! If not, the higher prices afford you a wiggle room to accommodate offers and do
          counteroffer with shipping or bundle discounts without operating at a loss. Luckily, OneShop features an
          automatic relisting tool that relists items after 30 days!
        </p>
        ​<p>Relisting items also means exposure to a fresh batch of likers and potential buyers!</p>​
        <h3>Share, share, share!</h3>​
        <p>
          Every seasoned Poshmark seller and Posh Ambassador knows how crucial it is to set aside time to share listings
          from your closet, as well as from other people’s listings, multiple times every day. Learn from them and take
          self-shares and community shares seriously. Your listings need to show up on users’ feeds to increase the
          chances of getting snatched up and purchased! Sometimes, it’s not about the dropped price per se that gets
          people to buy, but your listing being out there and seen by as many people as possible – one of them is bound
          to find your item desirable enough to hit “Buy Now” without even the need to drop the price on your part.{' '}
        </p>
        <p>
          As a Poshmark seller, you have more control to drive sales than you probably realize. You just need to think
          strategically and put in the hours. Tasks like sharing your closet, making offers, following, and relisting
          are important, but they demand precious time in a day that not all sellers may have. That is where a trusty
          Poshmark bot assistant comes in handy. Let OneShop handle the recurring tasks of sharing, following, making
          offers, and more with OneShop's Poshmark automation tools!
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
